// export const environment = {
//   production: true,
//   BaseUrl:"https://rseatapiproxy.azurewebsites.net/api",
//   authority:"https://rseatidentity.azurewebsites.net",
//   redirect_uri:"https://rseatangularclient.azurewebsites.net/auth-callback",
//   post_logout_redirect_uri:"https://rseatangularclient.azurewebsites.net",
//   silent_redirect_uri:"https://rseatangularclient.azurewebsites.net/silent-refresh.html"
// };

export const environment = {
  configLocation: window['configLocation'] || 'config-qa.json',
  production: window['production'] || false,
  BaseUrl: window['BaseUrl'] || 'https://aks-activities-integrationapi-qa.hospitalityrevolution.com/api/widget',
  authorizeIframeResponseOrigin: window['authorizeIframeResponseOrigin'] || 'https://aks-authorize-ui-qa.rguest.com',
  rGuestPayIframeResponsOrigin: window['rGuestPayIframeResponsOrigin'] || 'https://pay-blue.hospitalityrevolution.com',
  commonErrorMessage: window['commonErrorMessage'] || "Oops!... Some unexpected error occurred!",
  defaultPropertyName: window['defaultPropertyName'] || "Restaurant",
  generalPropertyName: window['generalPropertyName'] || "Property",
  redirectToAdminPortal: window['redirectToAdminPortal'] || "https://aks-activities-adminportal-qa.hospitalityrevolution.com/",
  SEAProduction: window['SEAProduction'] || false,
  restaurantIds: window['restaurantIds'] || [6, 7, 2156, 2107],
  NotesAsTagsMerchantIds: window['NotesAsTagsMerchantIds'] || [3],
  app_base_href: window['app_base_href'] || "",
  restaurantIdshowSMSRemainder:window['restaurantIdshowSMSRemainder'] ||  [],
  restaurantIdToHideLanguages:window['restaurantIdToHideLanguages'] ||  [],
  fetchStylesLiteralsFromBlob: window['fetchStylesLiteralsFromBlob'] || true
};
